export const PENDING_SHAREPOINT_TENANT_KEY = 'pendingSharePointTenant'
export const SHAREPOINT_CONSENT_REDIRECT_PATH = '/rms_v2/sharepoint-consent'
export const SHAREPOINT_CONSENT_RETURN_QUERY = 'sharepoint_app_consent'
export const SHAREPOINT_CONSENT_TENANT_QUERY = 'tenant_id'
export const SHAREPOINT_CONSENT_GRANTED_VALUE = 'granted'

export const TENANT_UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const isValidTenantUuid = (value: unknown): value is string =>
  typeof value === 'string' && TENANT_UUID_PATTERN.test(value)
